import { Edit } from '@mui/icons-material';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  TableCell,
  TableRow,
} from '@mui/material';
import React, { useState } from 'react';
import { ILegalRole } from '../../../Interfaces/ILegalRole';
import { ILegalRole_canInvite } from '../../../Interfaces/ILegalRole_canInvite';

interface IProps {
  legalRoleObject: ILegalRole;
  legalRoles: ILegalRole[];
  legalRoleCanInviteMap: ILegalRole_canInvite[];
  setLegalRoleCanInviteMap: React.Dispatch<
    React.SetStateAction<ILegalRole_canInvite[]>
  >;
}

export const LegalRoleCanInviteRow: React.FC<IProps> = ({
  legalRoleObject,
  legalRoles,
  legalRoleCanInviteMap,
  setLegalRoleCanInviteMap,
}) => {
  const [currentLegalRoleCanInviteMap, setCurrentLegalRoleCanInviteMap] =
    useState(
      legalRoleCanInviteMap.filter(
        x => x.From_idLegalRole === legalRoleObject.idLegalRole
      )
    );
  const [editLegalRoleCanInviteMap, setEditLegalRoleCanInviteMap] = useState(
    currentLegalRoleCanInviteMap
  );

  const [isOpenEdit, setIsOpenEdit] = useState(false);

  const handleOpen = () => {
    setEditLegalRoleCanInviteMap([...currentLegalRoleCanInviteMap]);
    setIsOpenEdit(true);
  };

  const handleClick = (idLegalRole: number) => {
    const testObject = editLegalRoleCanInviteMap.find(
      x => x.To_idLegalRole === idLegalRole
    );

    if (testObject === undefined) {
      setEditLegalRoleCanInviteMap([
        ...editLegalRoleCanInviteMap,
        {
          From_idLegalRole: legalRoleObject.idLegalRole,
          To_idLegalRole: idLegalRole,
        } as ILegalRole_canInvite,
      ]);
    } else {
      setEditLegalRoleCanInviteMap([
        ...editLegalRoleCanInviteMap.filter(
          x => x.To_idLegalRole !== idLegalRole
        ),
      ]);
    }
  };

  const handleSave = () => {
    setLegalRoleCanInviteMap([
      ...legalRoleCanInviteMap.filter(
        x => x.From_idLegalRole !== legalRoleObject.idLegalRole
      ),
      ...editLegalRoleCanInviteMap,
    ]);
    setCurrentLegalRoleCanInviteMap([...editLegalRoleCanInviteMap]);
    setIsOpenEdit(false);
  };

  return (
    <>
      <Dialog open={isOpenEdit} onClose={() => setIsOpenEdit(false)}>
        <DialogTitle>Einladeerlaubnis: {legalRoleObject.LegalRole}</DialogTitle>
        <DialogContent>
          <>
            Die Rolle <i>{legalRoleObject.LegalRole}</i> darf eingeladene
            Entitäten die folgenden Rollen zuweisen:
            <List
              sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
            >
              <>
                {legalRoles.map(x => (
                  <ListItem key={`to-${x.idLegalRole}`} disablePadding>
                    <ListItemButton
                      role={undefined}
                      onClick={() => handleClick(x.idLegalRole)}
                      dense
                    >
                      <ListItemIcon>
                        <Checkbox
                          edge='start'
                          checked={
                            editLegalRoleCanInviteMap.find(
                              y => y.To_idLegalRole === x.idLegalRole
                            ) !== undefined
                          }
                          tabIndex={-1}
                          disableRipple
                          inputProps={{
                            'aria-labelledby': String(x.idLegalRole),
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText
                        id={`to-text-${x.idLegalRole}`}
                        primary={x.LegalRole}
                      />
                    </ListItemButton>
                  </ListItem>
                ))}
              </>
            </List>
          </>
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' onClick={() => setIsOpenEdit(false)}>
            Abbruch
          </Button>
          <Button variant='contained' onClick={handleSave}>
            Übernehmen
          </Button>
        </DialogActions>
      </Dialog>

      <TableRow>
        <TableCell>{legalRoleObject.LegalRole}</TableCell>
        <TableCell>
          {legalRoles
            .filter(
              x =>
                currentLegalRoleCanInviteMap
                  .map(y => y.To_idLegalRole)
                  .indexOf(x.idLegalRole) > -1
            )
            .map(x => x.LegalRole)
            .join(', ')}
        </TableCell>
        <TableCell sx={{ width: 100 }}>
          <IconButton onClick={handleOpen}>
            <Edit />
          </IconButton>
        </TableCell>
      </TableRow>
    </>
  );
};
